import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "col-xxl-12" }
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6" }
const _hoisted_4 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_5 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h4", { class: "text-gray-800 fw-bolder" }, "Please Note!", -1)
const _hoisted_8 = { class: "fs-6 text-gray-600" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { align: "justify" }, "This page is intended for all Empowered Consumerism Partners who missed to purchase their PMA last month and therefore unable to earn their commissions for this month. ", -1)
const _hoisted_10 = { align: "justify" }
const _hoisted_11 = /*#__PURE__*/_createVNode("strong", null, "Requirement:", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = /*#__PURE__*/_createTextVNode("You have to purchase DOUBLE MAINTENANCE.")
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { align: "justify" }, "Minimum PMA for DI / SE / GE / GA - 0.6668 Positional Points", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column mb-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Your Inventory")
], -1)
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-225px rounded-start" }, "Product"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Quantity"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Position"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "Action")
  ])
], -1)
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_21 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("  This product is ")
const _hoisted_23 = /*#__PURE__*/_createVNode("u", null, "NOT", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" PMA of the month.")
const _hoisted_25 = /*#__PURE__*/_createVNode("option", { value: "L" }, "Left", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("option", { value: "R" }, "Right", -1)
const _hoisted_27 = {
  key: 1,
  href: "javascript:void(0);",
  class: "btn btn-success btn-sm dashboardFontStyle"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("    ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_font = _resolveComponent("font")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: [_ctx.widgetClasses, "card"]
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("p", _hoisted_10, [
                    _hoisted_11,
                    _hoisted_12,
                    _createVNode("u", null, [
                      _createVNode(_component_font, { color: "green" }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_14
                ])
              ])
            ])
          ]),
          _hoisted_15,
          _createVNode("div", _hoisted_16, [
            _createVNode("table", _hoisted_17, [
              _hoisted_18,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", null, [
                          _createVNode("a", _hoisted_20, "  " + _toDisplayString(item.product.toUpperCase()), 1),
                          _createVNode("span", _hoisted_21, "  Remaining:    " + _toDisplayString(Math.round(item.quantity)), 1),
                          (item.isPMAOfTheMonth != 1)
                            ? (_openBlock(), _createBlock(_component_font, {
                                key: 0,
                                style: {"font-size":"10px !important","color":"red !important"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_22,
                                  _hoisted_23,
                                  _hoisted_24
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "form-control dashboardFontStyle",
                        type: "text",
                        id: 'store_count_'+item.prodcode,
                        name: "",
                        style: {"width":"50px"},
                        "onUpdate:modelValue": ($event: any) => (_ctx.store_count[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.store_count[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("select", {
                        class: "form-select form-select-solid",
                        id: 'pos_' + item.prodcode,
                        style: {"width":"50%"},
                        "onUpdate:modelValue": ($event: any) => (_ctx.pos[index] = $event)
                      }, [
                        _hoisted_25,
                        _hoisted_26
                      ], 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelSelect, _ctx.pos[index]]
                      ])
                    ]),
                    _createVNode("td", null, [
                      _withDirectives(_createVNode("input", {
                        class: "form-control",
                        type: "text",
                        id: 'tousid_' + item.prodcode,
                        style: {"width":"150px"},
                        "onUpdate:modelValue": ($event: any) => (_ctx.tousid[index] = $event)
                      }, null, 8, ["id", "onUpdate:modelValue"]), [
                        [_vModelText, _ctx.tousid[index]]
                      ]),
                      _createVNode("input", {
                        type: "hidden",
                        id: 'prodcode_' + item.prodcode
                      }, null, 8, ["id"])
                    ]),
                    _createVNode("td", null, [
                      (_ctx.isprocessing[index] === '0')
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: "javascript:void(0);",
                            onClick: ($event: any) => {_ctx.send_instore(item.prodcode, index);},
                            class: "btn btn-success btn-sm dashboardFontStyle"
                          }, "Send", 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isprocessing[index] === '1')
                        ? (_openBlock(), _createBlock("a", _hoisted_27, "Processing..."))
                        : _createCommentVNode("", true),
                      _hoisted_28,
                      (_ctx.isBCOAccount == false)
                        ? (_openBlock(), _createBlock("a", {
                            key: 2,
                            href: "javascript:void(0);",
                            onClick: ($event: any) => {_ctx.viewExpiryDate(item.prodcode,item.product);},
                            class: "btn btn-info btn-sm dashboardFontStyle"
                          }, "Expiry Date", 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ], 2)
    ], 512), [
      [_vShow, !_ctx.loading && _ctx.isShowRetroPMAButton]
    ])
  ], 64))
}